import * as React from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@savgroup-front-common/primitive/ui/empty';

export function EmptyState({
  icon,
  title,
  description,
  className,
  ...props
}: Omit<React.ComponentProps<typeof Empty>, 'children'> & {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
}) {
  return (
    <Empty className={cn('py-6', className)} {...props}>
      <EmptyHeader>
        <EmptyMedia variant="icon">{icon}</EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
